import IMedicalFormElementProps from "../Types/IMedicalFormElement";
import { ComposedGeneralMedicalQuestions } from "./ComposedGeneralMedicalQuestions";
import { diabeticFormQuestions } from "./ComposedDiabeticMedicalQuestions";
import { pacemakerFormQuestions } from "./ComposedPacemakerMedicalQuestions";
import { radiationFormQuestions } from "./ComposedRadiationMedicalQuestions";

/** All medical form question components in display order for the single-page combined step. */
export const AllMedicalQuestions: React.FC<IMedicalFormElementProps>[] = [
  ...ComposedGeneralMedicalQuestions,
  ...pacemakerFormQuestions,
  ...radiationFormQuestions,
  ...diabeticFormQuestions
];
